import { DatePicker, Form, Input } from "antd";
import React from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import { getRequest } from "../../../http/axiosConfig/config";
import urls from "../../../http/endpoints/urls";
import { ReactComponent as CalendarIcon } from "../../../assets/icons/calendar-icon.svg";
import {generateTaxInvoicePDF} from './invoice_pdf'

export default function RequestInvoice() {
  let customerId = localStorage.getItem("userId");
  const [loading, setLoading] = useState(false);
  const [resMsg, setResMsg] = useState(null);
  const [requestForm] = Form.useForm();

  const requestInvoice = async (values) => {
    try {
      setLoading(true);
      let { fromDate, toDate, email } = values;
      let formattedFormDate = fromDate.format("DD-MMM-YYYY");
      let formattedToDate = toDate.format("DD-MMM-YYYY");

      console.log(formattedFormDate,formattedToDate);
      
      const res = await getRequest(
        urls.Report_View_Indiv_Cust_TaxInvoice(
          formattedFormDate,
           formattedToDate,
          customerId,
        )
      );
      
      generateTaxInvoicePDF(res.data);
      requestForm.resetFields();
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(error);
    }
  };

  if (resMsg)
    return (
      <div className="invoice-message">
        <p>{resMsg}</p>
        <button className="primary-btn" onClick={() => setResMsg(null)}>
          Got it
        </button>
      </div>
    );
  return (
    <div>
      <div className="page-header">Invoice Download</div>
      <Form
        className="invoice-form"
        form={requestForm}
        onFinish={requestInvoice}
        requiredMark={false}
      >
        <Form.Item
          label="From Date"
          name={"fromDate"}
          rules={[{ required: true, message: "Please select from date" }]}
        >
          <DatePicker 
            suffixIcon={<CalendarIcon />} 
            format="DD/MM/YYYY" 
            onChange={() => requestForm.setFieldsValue({ toDate: null })}
          />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => prevValues.fromDate !== currentValues.fromDate}
        >
          {({ getFieldValue }) => {
            const fromDateVal = getFieldValue('fromDate');
            
            const disabledToDate = (current) => {
              if (!fromDateVal || !current) return false;
              return (
                current < fromDateVal.clone().startOf('day') || 
                current > fromDateVal.clone().add(4, 'days').endOf('day')
              );
            };

            return (
              <Form.Item
                label="To Date"
                name={"toDate"}
                rules={[{ required: true, message: "Please select to date" }]}
              >
                <DatePicker 
                  suffixIcon={<CalendarIcon />} 
                  format="DD/MM/YYYY" 
                  disabled={!fromDateVal}
                  disabledDate={disabledToDate}
                />
              </Form.Item>
            );
          }}
        </Form.Item>
      </Form>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="primary-btn"
          onClick={() => requestForm.submit()}
          disabled={loading}
        >
          Download
        </button>
      </div>
    </div>
  );
}
